import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import IconButton from '@mui/material/IconButton';
import ArrowCircleRightTwoTone from '@mui/icons-material/ArrowCircleRightTwoTone';
import ArrowCircleLeftTwoTone from '@mui/icons-material/ArrowCircleLeftTwoTone';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import OverlayLoader from '../../components/OverlayLoader';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
registerLocale('es', es);
import { showToast } from '../../utils/toast';
import {
  validateEmail,
  getMysqlDate,
  base64Encode,
  sha256Encode,
  formatDate,
} from '../../utils/generals';
import { validarNickname } from '../../utils/nicknameValidator';
import HttpClient from '../../helpers/HttpClient'; 
import { months, years } from '../../constants';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.scss';

export default function Update() {
  const authState = useSelector((state) => state.auth);
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const [startDate, setStartDate] = React.useState(new Date());
  const userId =
    authState && authState.user ? authState.user.email : 'test';
  const [isOpen, setIsOpen] = React.useState(false);
  const [dataUser, setDataUser] = React.useState(null);
  const [phoneError, setPhoneError] = React.useState(false);

  const validarTelefonoInternacional = (phone: string): boolean => {
    if (!phone) return true; // Es opcional
    // Validar formato internacional: debe empezar con + y tener entre 10-15 dígitos
    const phoneRegex = /^\+\d{10,15}$/;
    return phoneRegex.test(phone.replace(/\s/g, ''));
  };

  const asegurarMasEnTelefono = (phone: string): string => {
    if (!phone) return '';
    // Convertir a string siempre y si no tiene +, agrégalo
    const phoneStr = String(phone).trim();
    if (!phoneStr.startsWith('+')) {
      return '+' + phoneStr;
    }
    return phoneStr;
  };

  const handleChange = (e) => {
      setDataUser({
        ...dataUser,
        fecha_nacimiento: e
      })

    setIsOpen(false);
    setStartDate(e);
  };

  const handleClick = (e) => {
    e.preventDefault();
    setIsOpen(true);
  };

  const loadUser = async () => {

    setOpen(true);

    const userQuery = await HttpClient().get(`/user/get/${userId}`)

    
    if (userQuery.data) {
      setOpen(false);
      const dateParts = userQuery.data.fecha_nacimiento.split("-")
      // Restar 1 al mes porque en JavaScript los meses son 0-11
      setStartDate(new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2])))
      // Asegurar que el teléfono tenga + si existe
      const userData = { ...userQuery.data };
      // El backend puede devolver el campo como 'whatsapp' o 'celular'
      const phoneField = userData.whatsapp || userData.celular;
      if (phoneField) {
        const phoneWithPlus = asegurarMasEnTelefono(phoneField);
        userData.whatsapp = phoneWithPlus;
        userData.celular = phoneWithPlus;
      }
      setDataUser(userData);
    } else {
      setOpen(false);
      showToast('Ha ocurrido un error');
      navigate(-1);
    }
  };

  React.useEffect(() => {
    loadUser();
  }, []);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const email = data.get('email').trim().toLowerCase();
    const email_repeat = data.get('email_repeat').trim().toLowerCase();
    const fullName = data.get('fullName').trim();
    const document = data.get('document').trim();
    const password = data.get('password').trim();
    const password_repeat = data.get('password_repeat').trim();
    const nickname = String(data.get('nickname')).trim();
    let phone = data.get('phone')?.trim() || '';
    // Asegurar que el teléfono tenga + si existe
    if (phone) {
      phone = asegurarMasEnTelefono(phone);
    }
    const birthday = startDate ? formatDate(startDate) : '';

    if (
      email == '' ||
      email_repeat == '' ||
      fullName == '' ||
      document == '' ||
      birthday == '' ||
      nickname == ''
    ) {
      showToast('Completa los datos');
    } else {
      const validacionNickname = validarNickname(nickname);
      if (!validacionNickname.valido) {
        showToast(validacionNickname.error || 'Nombre de usuario inválido');
      } else if (!validateEmail(email)) {
        showToast('El correo electrónico no es correcto');
      } else if (email != email_repeat) {
        showToast('Revisa que tu correo electrónico sea válido en ambos campos de texto');
      } else if (phone && !validarTelefonoInternacional(phone)) {
        showToast('Teléfono inválido. Debe ser formato internacional: +57 3001234567');
      } else {
        let dataForUpdate = {
          fullName: fullName,
          document: document,
          email: email,
          birthday: birthday,
          nickname: nickname,
          whatsapp: phone
        }
        let updateRun = true;
       
        if (password_repeat != '' || password != ''){
          if (password != password_repeat) {
            updateRun = false;
            showToast(
              'Revisa que tu contraseña sea la misma en ambos campos de texto'
            );
          }else{
            dataForUpdate = {
              ...dataForUpdate, 
              password: password,
              password_repeat: password_repeat
            }
            
          }
        }

        if (updateRun){
          setOpen(true);

          const result = await HttpClient().put(`/user/update/${userId}`, dataForUpdate);
          
          if (!result.error) {
            setOpen(false);
            showToast(
              'Usuario actualizado exitosamente',
              'success'
            );
          } else {
            setOpen(false);
            console.log(result);
            showToast('Ocurrió un error. Intenta nuevamente.', 'error');
          }
        }
      }
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <OverlayLoader open={open} />
      <CssBaseline />
      {dataUser ? (
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Actualización de datos
          </Typography>
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ mt: 3 }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  autoComplete="off"
                  name="fullName"
                  required
                  fullWidth
                  id="fullName"
                  label="Nombre completo"
                  value={dataUser.nombre_completo}
                  onChange={(event) => {
                    setDataUser({
                      ...dataUser,
                      nombre_completo: event.value
                    })
                  }}
                  autoFocus
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  autoComplete="off"
                  name="nickname"
                  required
                  fullWidth
                  id="nickname"
                  label="Nombre de usuario"
                  variant="outlined"
                  value={dataUser.nickname || ''}
                  inputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  autoComplete="off"
                  name="phone"
                  fullWidth
                  id="phone"
                  label="Celular/WhatsApp (opcional)"
                  placeholder="+57 (código país) número"
                  error={phoneError}
                  helperText={phoneError ? "Formato inválido. Usa: +57 3001234567" : "Formato internacional: +57 3001234567"}
                  value={dataUser?.whatsapp || ''}
                  onChange={(e) => {
                    let value = e.target.value;
                    // Permite + seguido de dígitos (formato internacional)
                    value = value.replace(/[^\d+]/g, "");
                    // Si no comienza con +, agregarlo automáticamente si está vacío
                    if (value && !value.startsWith("+")) {
                      value = "+" + value;
                    }
                    // Limitar a máximo 15 dígitos (estándar E.164) + el símbolo +
                    if (value.startsWith("+")) {
                      const digits = value.slice(1);
                      if (digits.length > 15) {
                        value = "+" + digits.slice(0, 15);
                      }
                    }
                    setDataUser({
                      ...dataUser,
                      whatsapp: value,
                    });
                    // Validar en tiempo real
                    if (value && !validarTelefonoInternacional(value)) {
                      setPhoneError(true);
                    } else {
                      setPhoneError(false);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  autoComplete="off"
                  name="birthday"
                  required
                  fullWidth
                  id="birthday"
                  label="Fecha de nacimiento"
                  onClick={handleClick}
                  value={startDate ? formatDate(startDate) : ''}
                  inputProps={{ readOnly: true }}
                />
                {isOpen ? (
                  <DatePicker
                    inline
                    locale="es"
                    dateFormat="yyyy-MM-dd"
                    selected={startDate}
                    onChange={(date) => handleChange(date)}
                    renderCustomHeader={({
                      date,
                      changeYear,
                      changeMonth,
                      decreaseMonth,
                      increaseMonth,
                      prevMonthButtonDisabled,
                      nextMonthButtonDisabled,
                    }) => (
                      <div
                        style={{
                          margin: 10,
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <IconButton
                          color="secondary"
                          onClick={decreaseMonth}
                          disabled={prevMonthButtonDisabled}
                        >
                          <ArrowCircleLeftTwoTone />
                        </IconButton>
                        <select
                          value={date.getFullYear()}
                          onChange={({ target: { value } }) =>
                            changeYear(value)
                          }
                        >
                          {years.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>

                        <select
                          value={months[date.getMonth()]}
                          onChange={({ target: { value } }) =>
                            changeMonth(months.indexOf(value))
                          }
                        >
                          {months.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>

                        <IconButton
                          color="secondary"
                          onClick={increaseMonth}
                          disabled={nextMonthButtonDisabled}
                        >
                          <ArrowCircleRightTwoTone />
                        </IconButton>
                      </div>
                    )}
                  />
                ) : null}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="document"
                  label="Documento"
                  name="document"
                  autoComplete="off"
                  value={dataUser.documento}
                  onChange={(event) => {
                    setDataUser({
                      ...dataUser,
                      documento: event.value
                    })
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  label="Correo electrónico"
                  name="email"
                  autoComplete="off"
                  variant="outlined"
                  value={dataUser.email}
                  inputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="email_repeat"
                  label="Confirmación correo electrónico"
                  name="email_repeat"
                  autoComplete="off"
                  variant="outlined"
                  value={dataUser.email}
                  inputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="password"
                  label="Contraseña"
                  type="password"
                  id="password"
                  autoComplete="new-password"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="password_repeat"
                  label="Contraseña"
                  type="password"
                  id="password_repeat"
                  autoComplete="off"
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Actualizar datos
            </Button>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Link
                  component="button"
                  variant="body2"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(-1);
                  }}
                >
                  Volver
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      ) : null}

      {/*<ToastContainer limit={3} autoClose={3000} />*/}
    </Container>
  );
}
